import { combineReducers } from "redux";

// Define reducers for individual state slices
const ideaReducer = (state = null, action) => {
  switch (action.type) {
    case 'IDEA_INIT':
      return null;
    case 'NEW_IDEA_SUCCESS': // When a new idea is successfully created via mutation
    case 'SET_IDEA': // When an existing idea is selected from the dropdown
      return action.payload;
    default:
      return state;
  }
};

const keywordReducer = (state = null, action) => {
  switch (action.type) {
    case 'KEYWORD_INIT':
      return null;
    case 'NEW_KEYWORD_SUCCESS':
      return action.payload;
    default:
      return state;
  }
};

const addedKeywordsLstReducer = (state = [], action) => {
  switch (action.type) {
    case 'IDEA_INIT': // Also clear keywords list when idea resets
    case 'ADDED_KEYWORDS_LST_INIT':
    case 'NEW_IDEA_SUCCESS': // Add this case to reset list on new idea
      return [];
    case 'ADDED_KEYWORDS_LST_SUCCESS':
      return action.payload;
    default:
      return state;
  }
};

const suggestedKeywordsReducer = (state = null, action) => {
  switch (action.type) {
    case 'SUGGESTED_KEYWORDS_INIT':
      return null;
    case 'SUGGESTED_KEYWORDS_SUCCESS':
      return action.payload;
    default:
      return state;
  }
};

const suggestedKeywordsInViewReducer = (state = null, action) => {
  switch (action.type) {
    case 'SUGGESTED_KEYWORDS_IN_VIEW_INIT':
      return null;
    case 'SUGGESTED_KEYWORDS_IN_VIEW_SUCCESS':
      return action.payload;
    default:
      return state;
  }
};

const selectedKeywordsReducer = (state = null, action) => {
  switch (action.type) {
    case 'SELECTED_KEYWORDS_INIT':
      return null;
    case 'SELECTED_KEYWORDS_UPDATE':
      return action.payload;
    default:
      return state;
  }
};

const categoryCountsReducer = (state = null, action) => {
  switch (action.type) {
    case 'SET_CATEGORY_COUNTS_INIT':
      return null;
    case 'SET_CATEGORY_COUNTS_SUCCESS':
      return action.payload;
    default:
      return state;
  }
};

const categoryDataReducer = (state = null, action) => {
  switch (action.type) {
    case 'SET_CATEGORY_DATA_INIT':
      return null;
    case 'SET_CATEGORY_DATA_SUCCESS':
      return action.payload;
    default:
      return state;
  }
};

const selectedCategoryReducer = (state = null, action) => {
  switch (action.type) {
    case 'SELECTED_CATEGORY_INIT':
      return null;
    case 'SELECTED_CATEGORY_SUCCESS':
      return action.payload;
    default:
      return state;
  }
};

const stepReducer = (state = 0, action) => {
  // Reset step when idea changes
  switch (action.type) {
    case 'IDEA_INIT': // Idea cleared/deleted
      return 0;
    case 'NEW_IDEA_SUCCESS': // New idea selected
      return 2; // Reset to keyword entry step
    case 'GET_STEP_INIT':
      return 0;
    case 'UPDATE_STEP':
      return action.payload;
    default:
      return state;
  }
};

// Reducer to track the list of all available ideas
const ideasListReducer = (state = [], action) => {
  switch (action.type) {
    case 'IDEAS_LIST_INIT':
      return [];
    case 'IDEAS_LIST_SUCCESS':
      return action.payload;
    case 'IDEA_DELETED':
      // Remove the deleted idea from the list
      return state.filter(idea => idea.id !== action.payload);
    default:
      return state;
  }
};

// Combine the slice reducers
const combinedSliceReducer = combineReducers({
  idea: ideaReducer,
  ideas: ideasListReducer,
  keyword: keywordReducer,
  addedKeywordsLst: addedKeywordsLstReducer,
  suggestedKeywords: suggestedKeywordsReducer,
  suggestedKeywordsInView: suggestedKeywordsInViewReducer,
  selectedKeywords: selectedKeywordsReducer,
  categoryCounts: categoryCountsReducer,
  categoryData: categoryDataReducer,
  selectedCategory: selectedCategoryReducer,
  step: stepReducer,
});

// Main reducer that handles cross-cutting actions first
const exploreReducer = (state, action) => {
  switch (action.type) {
    case 'SET_DEFAULT_IDEA_DETAILS':
      console.log("Reducer: SET_DEFAULT_IDEA_DETAILS", action.payload);
      // Apply updates needed for this specific action across multiple slices
      return {
        ...state, // Keep existing state for slices not explicitly changed
        idea: action.payload.idea,
        step: 1,
        addedKeywordsLst: action.payload.keywords || [], 
        suggestedKeywords: [], // Clear suggestions for the new idea
        keyword: "",         // Clear keyword input for the new idea
        loading: false,    // Ensure loading is false
        error: null,       // Clear any previous errors
      };
    // For all other actions, delegate to the combined slice reducer
    default:
      return combinedSliceReducer(state, action);
  }
};

export default exploreReducer;